import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const modalStyle = {
  overlay: {
    position: 'fixed',
    zIndex: 9999,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)'
  },
  content: {
    overflow: 'visible',
    backgroundColor: 'rgba(255, 255, 255, 0)',
    border: 'none',
    borderRadius: '0',
    outline: 'none',
    padding: '0',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: 'auto',
    maxWidth: '640px',
    maxHeight: '360px'
  }
};

const VideoContainer = styled.div`
  position: relative;
  margin: 0 10px;
  border: 10px solid #fff;
  overflow: visible;
  background: #000;

  @media (min-width: 380px) {
    height: 320px;
  }

  @media (min-width: 480px) {
    height: 360px;
  }

  .btn-close {
    padding: 5px;
    position: absolute;
    top: -16px;
    right: -16px;
    background: #fff;

    .icon {
      font-size: 12px;
    }
  }
`;

export class VideoModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool
  };

  constructor() {
    super();

    this.state = {
      modalIsOpen: false
    };

    Modal.setAppElement('body');
  }

  componentWillReceiveProps(nextProps) {
    const isOpen = nextProps && nextProps.isOpen;

    this.setState({ modalIsOpen: isOpen });
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    const { modalIsOpen } = this.state;

    return (
      <Modal
        style={modalStyle}
        isOpen={modalIsOpen}
        onRequestClose={this.closeModal}
        contentLabel="Modal"
      >
        <VideoContainer>
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/KwgP6KoMwQ4?rel=0&controls=1&showinfo=0&autoplay=1"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
          <div className="btn-close" onClick={this.closeModal}>
            <div className="icon hui-icon-close" />
          </div>
        </VideoContainer>
      </Modal>
    );
  }
}
